import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseInputComponent} from '@FormMakerReact/components/create-base-input-component';
import {FORM_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_DAY_INPUT_TYPE = 'postermywall-day-input';

export const POSTERMYWALL_DAY_INPUT: AddComponentTypeOptions = createBaseInputComponent({
  inputFieldType: POSTERMYWALL_DAY_INPUT_TYPE,
  inputName: 'day',
  dataMarkerAttribute: 'data-is-pmw-form-birthday-input',
  displayName: 'Birthday',
  placeholder: 'DD',
  style: FORM_INPUT_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-birthday-input') !== null && el.getAttribute('name') === 'day',
  additionalAttributes: {maxlength: 2, minlength: 2, type: 'number', min: 1, max: 31},
});
